export default __webpack_public_path__ + "static/media/neon-hallway.5da6ec6c.png";